import { render } from "./NewClass.vue?vue&type=template&id=774d8932&scoped=true"
import script from "./NewClass.vue?vue&type=script&lang=js"
export * from "./NewClass.vue?vue&type=script&lang=js"

import "./NewClass.vue?vue&type=style&index=0&id=774d8932&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774d8932"]])

export default __exports__